export { default as Img200 } from './processed/200/Britannia-S1.jpg';
export { default as Img400 } from './processed/400/Britannia-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Britannia-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Britannia-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Britannia-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      51,
      151,
      203
    ],
    "_population": 1181,
    "_hsl": [
      0.5570175438596491,
      0.5984251968503935,
      0.4980392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      136,
      195,
      236
    ],
    "_population": 20,
    "_hsl": [
      0.5683333333333334,
      0.7246376811594204,
      0.7294117647058824
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      32,
      60,
      75
    ],
    "_population": 2624,
    "_hsl": [
      0.5581395348837209,
      0.4018691588785047,
      0.20980392156862746
    ]
  },
  "Muted": {
    "_rgb": [
      175,
      121,
      80
    ],
    "_population": 2081,
    "_hsl": [
      0.0719298245614035,
      0.37254901960784315,
      0.5
    ]
  },
  "LightMuted": {
    "_rgb": [
      179,
      189,
      196
    ],
    "_population": 62,
    "_hsl": [
      0.568627450980392,
      0.12592592592592608,
      0.7352941176470589
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Britannia-S1.js